import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

export function openConfirmDialog(dialog: MatDialog, data: any): MatDialogRef<ConfirmDialogComponent> {
  return dialog.open(ConfirmDialogComponent, {
    panelClass: 'confirm-dialog-panel',
    backdropClass: 'confirm-dialog-backdrop',
    autoFocus: false,
    restoreFocus: true,
    data
  });
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmDialogComponent {
  message: string = "Are you sure?"
  confirmButtonText = "Yes"
  cancelButtonText = "Cancel"
  isDanger = false
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>) {
      this.dialogRef.addPanelClass('confirm-dialog-panel');
      if(data){
        this.message = data.message || this.message;
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
      this.isDanger = data.danger === true || /delete|remove/i.test(this.confirmButtonText);
      }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  
  onCancel() {
    this.dialogRef.close(false);
  }
}